import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import * as assign from 'deep-assign';
import * as createLogger from 'redux-logger';

import { loadState, saveState } from './localStorage';
import reducer from '../reducers';

import IState from '../interfaces/states';

let initialState = loadState() || {};
let finishedTimer;

interface PhantomWindow extends Window {
    callPhantom(err?: Error),
}

function finished(err: Error) {
    console.info('finished report');

    const eWindow = window as PhantomWindow;

    if (typeof eWindow.callPhantom === 'function') {
        eWindow.callPhantom();
    }
}

function configureStore(overrideState?) {
    if (overrideState) {
        initialState = assign(initialState, overrideState);
    }

    const logger = createLogger({ collapsed: true});
    const store = createStore(
        reducer,
        initialState,
        applyMiddleware(
            thunk,
            logger
        ),
    );

    store.subscribe(() => {
        const state: IState = store.getState() as IState;
        const dispatch = store.dispatch;

        saveState({
            reportSettings: state.reportSettings,
        }, dispatch);

        if (state.widgetData.isLoading === false) {
            console.log('no widget is currently loading, will wait to call callback');
            clearTimeout(finishedTimer);
            finishedTimer = setTimeout(finished, 4000);
        } else {
            clearTimeout(finishedTimer);
        }
    });

    return store;
}

export default configureStore;


// WEBPACK FOOTER //
// ./src/store/configureStore.ts